<template>
	<div>
		<div
			:class="{
				[$style.air__sidebar]: true,
				[$style.air__sidebar__toggled]: visible
			}"
		>
			<vue-custom-scrollbar :style="{ height: '100%' }">
				<div :class="$style.air__sidebar__inner">
					<a
						:class="$style.air__sidebar__close"
						@click="close()"
					>
						<a-icon type="close" />
					</a>
					<h5 class="text-uppercase">
						<strong>Configuración</strong>
					</h5>
					<div
						class="air__utils__line"
						:style="{ marginTop: '25px', marginBottom: '30px' }"
					/>
					<p class="mb-2 text-right text-dark font-weight-700">
						🎨 Personaliza a tu gusto la plataforma y ajústala a tu medida
					</p>
					<div :class="$style.air__sidebar__type">
						<!-- <div :class="$style.air__sidebar__type__title">
							<span>Menu lateral</span>
						</div>
						<div :class="[$style.air__sidebar__type__items, 'mb-4']">
							<a-radio-group
								:default-value="$settings.menuLayoutType"
								@change="selectMenuLayoutType"
							>
								<div class="row">
									<div class="col-6">
										<div class="mb-2">
											<a-radio :value="'left'">
												Izquierda
											</a-radio>
										</div>
									</div>
									<div class="col-6">
										<div class="mb-2">
											<a-radio :value="'top'">
												Arriba
											</a-radio>
										</div>
									</div>
								</div>
							</a-radio-group>
						</div> -->
						<div :class="$style.air__sidebar__item">
							<div :class="$style.air__sidebar__label">
								Modo Oscuro
							</div>
							<div :class="$style.air__sidebar__container">
								<a-switch
									:checked="$settings.dark"
									@click="settingChange($event, 'dark')"
								/>
							</div>
						</div>
						<div :class="$style.air__sidebar__item">
							<div :class="$style.air__sidebar__label">
								Modo compacto
							</div>
							<div :class="$style.air__sidebar__container">
								<a-switch
									:checked="$settings.isMenuCollapsed"
									@click="settingChange($event, 'isMenuCollapsed')"
								/>
							</div>
						</div>
						<div :class="$style.air__sidebar__item">
							<div :class="$style.air__sidebar__label">
								Fijar menu
							</div>
							<div :class="$style.air__sidebar__container">
								<a-switch
									:checked="!$settings.isMenuUnfixed"
									@click="settingChange($event, 'isMenuUnfixed')"
								/>
							</div>
						</div>
						<!-- <div :class="$style.air__sidebar__item">
							<div :class="$style.air__sidebar__label">
								Tema
							</div>
							<div :class="$style.air__sidebar__container">
								<air-color-picker
									:value="$settings.menuColor"
									:setting="'menuColor'"
									:colors="['white', 'gray', 'blue', 'dark']"
								/>
							</div>
						</div> -->
					</div>
					<div :class="$style.air__sidebar__type">
						<div :class="$style.air__sidebar__type__title">
							<span>Submenus laterales</span>
						</div>
						<div :class="[$style.air__sidebar__type__items, 'mb-4']">
							<a-radio-group
								:default-value="$settings.menuType"
								@change="selectMenuType"
							>
								<div class="row">
									<div class="col-6">
										<div class="mb-2">
											<a-radio
												:value="'default'"
												:disabled="$settings.menuLayoutType !== 'left'"
											>
												Estandar
											</a-radio>
										</div>
										<div class="mb-2">
											<a-radio
												:value="'flyout'"
												:disabled="$settings.menuLayoutType !== 'left'"
											>
												Flyout
											</a-radio>
										</div>
									</div>
									<div class="col-6">
										<div class="mb-2">
											<a-radio
												:value="'compact'"
												:disabled="$settings.menuLayoutType !== 'left'"
											>
												Compacto
											</a-radio>
										</div>
									</div>
								</div>
							</a-radio-group>
						</div>
					</div>
					<div
						:class="$style.air__sidebar__type"
						class="mb-4"
					>
						<div :class="$style.air__sidebar__type__title">
							<span>Transición entre ventanas</span>
						</div>
						<div :class="$style.air__sidebar__type__items">
							<a-select
								:default-value="$settings.routerAnimation"
								style="width: 100%;"
								@change="selectRouterAnimation"
							>
								<a-select-option value="none">
									None
								</a-select-option>
								<a-select-option value="slide-fadein-up">
									Deslizar hacia arriba
								</a-select-option>
								<a-select-option value="slide-fadein-right">
									Deslizar a la derecha
								</a-select-option>
								<a-select-option value="fadein">
									Desvanecer
								</a-select-option>
								<a-select-option value="zoom-fadein">
									Zoom
								</a-select-option>
							</a-select>
						</div>
					</div>

					<div
						:class="$style.air__sidebar__type"
						class="mb-4"
					>
						<div :class="$style.air__sidebar__type__title">
							<span>Personalización</span>
						</div>

						<div :class="$style.air__sidebar__type__items">
							<div :class="$style.air__sidebar__item">
								<div :class="$style.air__sidebar__label">
									Fondo gris
								</div>
								<div :class="$style.air__sidebar__container">
									<a-switch
										:checked="$settings.isGrayBackground"
										@click="settingChange($event, 'isGrayBackground')"
									/>
								</div>
							</div>

							<div :class="$style.air__sidebar__item">
								<div :class="$style.air__sidebar__label">
									Renderizar sombras
								</div>
								<div :class="$style.air__sidebar__container">
									<a-switch
										:checked="$settings.isCardShadow"
										@click="settingChange($event, 'isCardShadow')"
									/>
								</div>
							</div>

							<div :class="$style.air__sidebar__item">
								<div :class="$style.air__sidebar__label">
									Esquinas cuadradas
								</div>
								<div :class="$style.air__sidebar__container">
									<a-switch
										:checked="$settings.isSquaredBorders"
										@click="settingChange($event, 'isSquaredBorders')"
									/>
								</div>
							</div>

							<div :class="$style.air__sidebar__item">
								<div :class="$style.air__sidebar__label">
									Bordes en contenido
								</div>
								<div :class="$style.air__sidebar__container">
									<a-switch
										:checked="!$settings.isBorderless"
										@click="settingChange($event, 'isBorderless')"
									/>
								</div>
							</div>

							<div :class="$style.air__sidebar__item">
								<div :class="$style.air__sidebar__label">
									Sombras en menú
								</div>
								<div :class="$style.air__sidebar__container">
									<a-switch
										:checked="$settings.isMenuShadow"
										@click="settingChange($event, 'isMenuShadow')"
									/>
								</div>
							</div>
						</div>
					</div>

					<div
						:class="$style.air__sidebar__type"
						class="mb-4"
					>
						<div :class="$style.air__sidebar__type__title">
							<span>Otros</span>
						</div>

						<div :class="$style.air__sidebar__type__items">
							<div :class="$style.air__sidebar__item">
								<div :class="$style.air__sidebar__label">
									Fijar Topbar
								</div>
								<div :class="$style.air__sidebar__container">
									<a-switch
										:checked="$settings.isTopbarFixed"
										@click="settingChange($event, 'isTopbarFixed')"
									/>
								</div>
							</div>

							<!-- <div :class="$style.air__sidebar__item">
								<div :class="$style.air__sidebar__label">
									Login color
								</div>
								<div :class="$style.air__sidebar__container">
									<air-color-picker :value="$settings.systemLayoutColor"
									:setting="'systemLayoutColor'"
									:colors="['white', 'gray', 'blue', 'dark', 'image']"/>
								</div>
							</div> -->

							<div :class="$style.air__sidebar__item">
								<div :class="$style.air__sidebar__label">
									Extender contenido
								</div>
								<div :class="$style.air__sidebar__container">
									<a-switch
										:checked="$settings.isContentNoMaxWidth"
										@click="settingChange($event, 'isContentNoMaxWidth')"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</vue-custom-scrollbar>
		</div>
	</div>
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar';
// import AirColorPicker from '@/system/layouts/app/sidebar/partials/colorPicker';

export default {
	components: {
		vueCustomScrollbar
		// AirColorPicker
	},
	data() {
		return {
			visible: false
		};
	},
	created() {
		this.$hub.$on('_toggleSettings', () => {
			this.visible = !this.visible;
		});
	},
	destroyed() {
		this.$hub.$off('_toggleSettings');
	},
	methods: {
		close() {
			this.visible = false;
		},
		settingChange(e, setting) {
			const value = !this.$settings[setting];
			this.$store.commit('CHANGE_SETTING', { setting, value });
		},
		selectMenuType(e) {
			const setting = 'menuType';
			const { value } = e.target;
			this.$store.commit('CHANGE_SETTING', { setting, value });
		},
		selectMenuLayoutType(e) {
			const setting = 'menuLayoutType';
			const { value } = e.target;
			this.$store.commit('CHANGE_SETTING', { setting, value });
		},
		selectRouterAnimation(value) {
			const setting = 'routerAnimation';
			this.$store.commit('CHANGE_SETTING', { setting, value });
		}
	}
};
</script>

<style lang="scss" module>
@import './style.module.scss';
</style>
